"use client"
import { GoodEndingSiteHeader } from "./GoodEndingSiteHeader"

export const GoodEndingTitleSection = () => {
  return (
    <GoodEndingSiteHeader />
  )
}
